import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

const searchCode = "<Search onSearch={() => null} />";

const searchDemo = {
    code: searchCode
};

export const SearchDemo: FunctionComponent = () => {
    return (
        <Demo demo={searchDemo}>
            <ComponentProps componentName="Search" />
        </Demo>
    );
};
